module.exports = __webpack_public_path__ + "img/3.11fa4475.jpg";